import styled from "styled-components";

export const LogoContainer = styled.img`
  width: 125px;
  margin-top: 125px;
`;